const logo = [
  ['save'],
  ['translate', [0, -1.36]],
  ['path', ['M86.179,87.629a10.543,10.543,0,0,1-7.233,2.887c-5.921,0-9.858-4.492-9.858-10.121,0-5.833,4.171-10.033,9.654-10.033a8.161,8.161,0,0,1,4.987,1.283,3.5,3.5,0,0,0-.292,1.458,2.966,2.966,0,0,0,3.237,3.033A3.148,3.148,0,0,0,89.737,72.7c0-3.383-4.346-6.8-10.879-6.8A14.368,14.368,0,0,0,64.1,80.454c0,8.75,6.183,14.554,14.846,14.554a15.2,15.2,0,0,0,10.033-3.675Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-163.98, 0]],
  ['path', ['M314.383,89.448V65.386a.844.844,0,0,0-.729-.817l-5.833-.583a.819.819,0,0,0-.9.817v3.121a.835.835,0,0,0,.817.817h2.013v7.292a8.017,8.017,0,0,0-5.192-1.779c-5.046,0-8.954,4.346-8.954,9.771,0,5.629,3.7,9.6,8.662,9.6a7.758,7.758,0,0,0,5.512-2.392v2.042h7.408v-3.85l-2.8.029Zm-4.667-1.692a6.639,6.639,0,0,1-4.433,1.867c-2.742,0-4.958-2.042-4.958-5.629,0-3.7,2.333-5.717,4.958-5.717a7.473,7.473,0,0,1,4.433,1.458Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-110.925, -6.021]],
  ['path', ['M239.512,73.886a.845.845,0,0,0-.758-.817l-5.833-.583a.819.819,0,0,0-.9.817v3.121a.835.835,0,0,0,.817.817h2.012v4.812a8.017,8.017,0,0,0-5.192-1.779c-5.046,0-8.954,4.346-8.954,9.771,0,5.629,3.7,9.6,8.662,9.6a7.758,7.758,0,0,0,5.512-2.392V99.29h7.408V95.44h-2.771Zm-4.667,19.892a6.639,6.639,0,0,1-4.433,1.867c-2.742,0-4.958-2.042-4.958-5.629,0-3.7,2.333-5.717,4.958-5.717a7.473,7.473,0,0,1,4.433,1.458Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-63.396, -25.019]],
  ['path', ['M170.342,106.5a7.229,7.229,0,0,0-1.458-4.7c-1.312-1.633-3.5-2.508-6.708-2.508-5.075,0-7.408,2.421-7.408,4.725a2.381,2.381,0,0,0,2.479,2.508,2.417,2.417,0,0,0,2.508-2.421,3.511,3.511,0,0,0-.175-.933,4.916,4.916,0,0,1,1.837-.292,4.354,4.354,0,0,1,3.675,1.371,4.075,4.075,0,0,1,.729,2.567v1.487a20.771,20.771,0,0,0-4.725-.525c-4.433,0-7.5,2.129-7.5,5.629s2.858,5.25,6.067,5.25a9.872,9.872,0,0,0,6.271-2.392v2.042h7.2v-3.85h-2.8Zm-4.521,7.117a8.074,8.074,0,0,1-4.7,1.662c-1.662,0-2.771-.817-2.771-2.3,0-1.721,1.371-2.742,3.617-2.742a16.466,16.466,0,0,1,3.85.438v2.946Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-224.613, -4.052]],
  ['path', ['M384.262,75.825a3.157,3.157,0,0,0,3.15-3.062A3.062,3.062,0,0,0,384.35,69.7a3.157,3.157,0,0,0-3.15,3.062A3.081,3.081,0,0,0,384.262,75.825Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-220.717, -25.869]],
  ['path', ['M383.2,100.5h-7.5v3.908h2.858v10.908H375.7v3.85h10.267v-3.85H383.2Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-246.996, -25.019]],
  ['path', ['M431.379,108.254c0-4.958-3.121-8.954-9.1-8.954-5.746,0-9.479,4.433-9.479,9.712,0,5.8,4.229,9.654,10.325,9.654a13.934,13.934,0,0,0,7.087-1.692l.379-4.171a14.088,14.088,0,0,1-6.8,1.954c-3.121,0-5.512-1.283-6.154-4.171h13.475A10.217,10.217,0,0,0,431.379,108.254Zm-13.737-.933c.525-3.062,2.567-4.258,4.608-4.258a4.153,4.153,0,0,1,4.492,4.258Z']],
  ['fill', ['non-zero']],
  ['restore'],
  ['save'],
  ['translate', [-293.534, -28.135]],
  ['path', ['M479.754,108.133h.788v-3.792H479.2v.787h-.7V103.7h4.842v1.429h-.729v-.787h-1.342v3.792h.788v.7h-2.3v-.7Zm4.054,0h.729l.175-3.733h-.787v-.7h1.662l1.517,3.325,1.517-3.325h1.662v.7H489.5l.175,3.733h.787v.7h-2.071v-.7h.642l-.146-3.412-1.575,3.471h-.379l-1.6-3.471-.087,3.412h.642v.7H483.75v-.7Z']],
  ['fill', ['non-zero']],
  ['restore']
];

export default logo;



// WEBPACK FOOTER //
// ./src/reports/partials/logo.js